import * as React from "react";
import RoleDetails from "src/components/RoleDetails";
import RoleQuery from "src/queries/RoleQuery";
import UpsertRole from "src/mutations/UpsertRole";
import { Redirect } from "react-router";

export interface Props {
  match: {
    params: {
      roleName: string | null;
    };
  };
}

export default (props: Props) => {
  const name = props.match.params.roleName;
  if (name) {
    return (
      <RoleQuery name={name}>
        {({ loading, error, data }) => {
          if (!data) {
            return null;
          }
          if (error) {
            return <h1>ERROR</h1>;
          }
          return (
            <UpsertRole name={name}>
              {(upsert, result) => (
                <RoleDetails
                  admin={true}
                  error={result.error && result.error.message}
                  role={data.role}
                  onSubmit={upsert}
                  loading={loading || result.loading}
                />
              )}
            </UpsertRole>
          );
        }}
      </RoleQuery>
    );
  } else {
    return (
      <UpsertRole name={null} add={true}>
        {(upsert, result) => {
          if (result.data && result.data.upsertRole.name) {
            return <Redirect to={"/roles/" + result.data.upsertRole.name} />;
          }
          return (
            <RoleDetails
              onSubmit={upsert}
              loading={result.loading}
              admin={true}
              add={true}
              role={null}
            />
          );
        }}
      </UpsertRole>
    );
  }
};



// WEBPACK FOOTER //
// ./src/screens/Role/RolePage.tsx